/**
 * Entrées de navigation du header, partagées par la barre desktop
 * (`HeaderNav`) et le tiroir mobile (`HeaderMobileDrawer`) : les deux doivent
 * lister les mêmes destinations.
 */
export interface HeaderMenuEntry {
  name: string
  /** Chaîne vide = destination pas encore branchée. */
  href: string
  icon: string
}

/** Entrée dépliant les menus secondaires ; rendue à part de la barre. */
export const HEADER_MENU_AUTRES: HeaderMenuEntry = {
  name: 'AUTRES',
  href: '',
  icon: 'lucide:menu',
}

export const HEADER_MENUS_PRIMAIRES: HeaderMenuEntry[] = [
  {
    name: 'TABLEAU DE BORD',
    href: '/',
    icon: 'lucide:table',
  },
  {
    name: 'BIENS',
    href: '/annonces',
    icon: 'lucide:house',
  },
  {
    name: 'ACQUÉREURS',
    href: '',
    icon: 'lucide:square-user-round',
  },
  {
    name: 'PROPRIÉTAIRES',
    href: '',
    icon: 'lucide:id-card',
  },
  {
    name: 'DIFFUSER',
    href: '/diffusion',
    icon: 'lucide:share-2',
  },
  {
    name: 'STATISTIQUES',
    href: '',
    icon: 'lucide:chart-column-stacked',
  },
]

export const HEADER_MENUS_SECONDAIRES: HeaderMenuEntry[] = [
  {
    name: 'Calculette',
    href: '/calculette',
    icon: 'lucide:calculator',
  },
  {
    name: 'FAQ',
    href: '/faq',
    icon: 'lucide:message-circle-question',
  },
  {
    name: 'Paramètres compte',
    href: '/options',
    icon: 'lucide:wrench',
  },
]

/**
 * Une entrée est active sur sa route et ses sous-routes — sauf l'accueil, qui
 * ne s'allume que sur `/` (sinon elle le serait partout).
 */
export function isHeaderMenuActive(entry: HeaderMenuEntry, path: string): boolean {
  if (!entry.href)
    return false
  return entry.href === '/' ? path === '/' : path.startsWith(entry.href)
}
